<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ activeArrData.length }})">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 my-3" *ngFor="let item of activeArrData, index as i">
        <mat-card class="has-outline-menu link" *ngIf="item.status === 'Activo'">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Menú" (click)="editLink(item)">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
              [matTooltip]="item.status === 'Activo' ? 'Deshabilitar Menú' :  'Habilitar Menú'"
              (click)="changeStatus(item)">
              <mat-icon>{{ item.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Menú" (click)="delete(item)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <mat-card-header class="d-flex flex-column-reverse align-items-center justify-content-center text-center">
            <mat-icon *ngIf="item.items.length > 0" class="mat-icon link-submenu">menu_open</mat-icon>
            <mat-icon *ngIf="item.type === 1" class="mat-icon link-icon c-icon">subdirectory_arrow_left</mat-icon>
            <mat-icon *ngIf="item.type === 2" class="mat-icon link-icon c-icon">north_east</mat-icon>
            <img [src]="item.img" class="mat-icon"
              onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
            <mat-card-title>{{item.value}}</mat-card-title>
            <mat-card-subtitle>{{item.url | maxLength: 20}}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Deshabilitados ({{ inactiveArrData.length }})">
    <div class="row disabled-content">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 my-3" *ngFor="let item of inactiveArrData, index as i">
        <mat-card class="has-outline-menu item" *ngIf="item.status === 'Desactivado'">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceMedata" [ngClass]="mantenienceMedata ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
              [matTooltip]="item.status === 'Activo' ? 'Deshabilitar Menú' :  'Habilitar Menú'"
              (click)="changeStatus(item)">
              <mat-icon>{{ item.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceMedata" [ngClass]="mantenienceMedata ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Menú" (click)="delete(item)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <mat-card-header class="d-flex flex-column-reverse align-items-center justify-content-center text-center">
            <mat-icon *ngIf="item.type === 1" class="mat-icon link-icon c-icon">subdirectory_arrow_left</mat-icon>
            <mat-icon *ngIf="item.type === 2" class="mat-icon link-icon c-icon">north_east</mat-icon>
            <img [src]="item.img" class="mat-icon"
              onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
            <mat-card-title>{{item.value}}</mat-card-title>
            <mat-card-subtitle>{{item.url | maxLength: 20}}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>